import React from 'react';
import StepInterpolatorEditor from './StepInterpolatorEditor'
import LinearInterpolatorEditor from './LinearInterpolatorEditor'
import StepGeoPointInterpolatorEditor from './StepGeoPointInterpolatorEditor'
import LinearGeoPointInterpolatorEditor from './LinearGeoPointInterpolatorEditor'
import GreatCircleInterpolatorEditor from './GreatCircleInterpolatorEditor'
import RhumbInterpolatorEditor from './RhumbInterpolatorEditor'

function createEditor( interpolator, prps ) {

  if ( interpolator == null ) {
    return null;
  }
  
  const props = {
    ...prps,
    interpolator  
  }

  switch ( interpolator.type ) {
    case StepInterpolatorEditor.TYPE: return <StepInterpolatorEditor {...props} />
    case LinearInterpolatorEditor.TYPE: return <LinearInterpolatorEditor {...props} />
    case GreatCircleInterpolatorEditor.TYPE: return <GreatCircleInterpolatorEditor {...props} />
    case RhumbInterpolatorEditor.TYPE: return <RhumbInterpolatorEditor {...props} />
    case LinearGeoPointInterpolatorEditor.TYPE: return <LinearGeoPointInterpolatorEditor {...props} />
    case StepGeoPointInterpolatorEditor.TYPE: return <StepGeoPointInterpolatorEditor {...props} />
    default: return <div />
  }
}

module.exports = {
  createEditor
}
